<template>
  <div>
    <!-- Breadcrumbs for normal mode -->
    <div v-if="!embedded" class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>
    
    <!-- Back button for embedded mode -->
    <div v-else class="p-4 border-b flex items-center justify-between">
      <button 
        @click="goBackToHome" 
        class="flex items-center text-gray-600 hover:text-gray-800"
      >
        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
        </svg>
        {{ $t('go.actions.back_to_orders') }}
      </button>
      <h3 class="text-lg font-medium text-gray-900">{{ type == 'order' ? $t('go.lista_ordini.title') : $t('go.lista_ordini.title_drafts') }}</h3>
    </div>
    
    <div class="p-6 pb-0">
      <div class="flex items-center justify-between mb-4">
        <label v-if="!embedded" class="block text-sm font-medium mb-2">{{ type == 'order' ? $t('go.lista_ordini.label') : $t('go.lista_ordini.label_drafts') }}</label>
        <Link :href="route('modules.ordini.documento', -1)+'?type='+(type == 'order' ? 'order' : 'draft')" class="text-white bg-gray-500 font-medium rounded-lg text-sm px-4 py-2.5 text-center">
          {{ $t('go.actions.new') }}
        </Link>
      </div>
      <PageServerTable
        :headers="headers" 
        :items="itemslist" 
        :items-per-page.sync="ipp" 
        :items-per-page-options="ippo" 
        :sort-by="sortby" 
        :items-length="itemscount" 
        :reload-fn="reload"
        :item-value="'id'"

        :page="page"
        show-current-page
        >
        <template #item.customer="{ item }">
            <span>{{ item.company_name ? item.company_name + ' ' + item.cust_supp : '' }}</span>
        </template>
        <template #item.id="{ item }">
            <div class="flex gap-2">
              <Link :href="route('modules.ordini.documento', item.id)" class="bg-blue-400 text-white px-4 py-2 rounded hover:bg-blue-500">{{ $t('go.actions.open') }}</Link>
              <Link
                v-if="explicitReview && item.doc_status != 'order' && item.id > 0"
                :href="route('modules.ordini.documento', item.id) + '?explicitReview=1'"
                class="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
              >Revisiona</Link>
              <button 
                @click="printDocument(item.id)" 
                class="bg-green-500 text-white px-3 py-2 rounded hover:bg-green-600"
                title="Stampa documento"
                v-if="item.company_name != 'Seleziona' && (item.doc_status == 'offert' || item.doc_status == 'order' || allowDraftPrint)"  
              >
                <v-icon name="co-print" scale="0.9" />
              </button>
            </div>
        </template>
        <template #item.doc_status="{ item }">
            <span>
              {{ $t('go.doc_status.' + item.doc_status) || item.doc_status }}
            </span>
        </template>
        <template #item.doc_date="{ item }">
            <span>
              {{ item.doc_date ? formatDate(item.doc_date) : '-' }}
            </span>
        </template>
        <template #item.is_on_mago="{ item }">
            <v-icon v-if="item.is_on_mago" name="md-checkbox-round" scale="1.2" fill="green" />
        </template>
        <template #item.is_quota_on_mago="{ item }">
            <v-icon v-if="item.is_quota_on_mago" name="md-checkbox-round" scale="1.2" fill="green" />
        </template>
        <template #item.new_order_number="{ item }">
            <v-icon v-if="item.new_order_number > 0" name="md-checkbox-round" scale="1.2" fill="green" />
        </template>
        <template #item.correctable="{ item }">
            <v-icon v-if="item.correctable != 0" name="md-checkbox-round" scale="1.2" fill="green" />
        </template>
        <template #item.approval="{ item }">
            <v-icon v-if="item.approval != 0" name="md-checkbox-round" scale="1.2" fill="green" />
        </template>
      </PageServerTable>
    </div>
  </div>
</template>

<script>
import { Link, router, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Pagination from '@/Components/Pagination.vue';
import PageServerTable from '@/Components/PageServerTable.vue';
import axios from 'axios';

export default {
  props: ['type', 'items', 'count', 'ippo', 'embedded', 'allowDraftPrint', 'explicitReview'],
  components: {
    Link,
    BreadCrumbs,
    Pagination,
    PageServerTable
  },
  data() {
    return {
      search: this.filters?.search || "",
      selected: [],
      //deletions: [],
      showFilters: false,
      headers: [],
      sortby: [],
      ipp: 10,
      page: 1,
      itemsembeddedreload: null,
      itemscountreload : null
    };
  },
  computed:{
    navigation() {
      return this.type !== 'order'
        ? [
            { name: 'Dashboard', href: route('dashboard') },
            { name: this.$t('go.breadcrumb.gestione_ordini'), href: route('modules.home', 'gestione-ordini') },
            { name: this.$t('go.breadcrumb.lista_proposte_offerte'), href: route('modules.ordini.lista-offerte') }
          ]
        : [
            { name: 'Dashboard', href: route('dashboard') },
            { name: this.$t('go.breadcrumb.gestione_ordini'), href: route('modules.home', 'gestione-ordini') },
            { name: this.$t('go.breadcrumb.lista_ordini'), href: route('modules.ordini.lista-ordini') }
          ];
    },
    itemslist(){
      if (this.itemsembeddedreload)
        return this.itemsembeddedreload;
      return this.items;
    },
    itemscount(){
      if (this.itemscountreload)
        return this.itemscountreload;
      return this.count;
    }
  },
  methods: {
    reload(sortby = undefined, itemsperpage = undefined, page = undefined, afterdeletion = false) {
      /*if (afterdeletion)
      return;*/

        if (sortby) this.sortby = sortby;
        if (itemsperpage) this.ipp = itemsperpage;
        if (page) this.page = page;

        //sortBy e ipp passano solo il valore aggiornato come $event, non si modifica realmente, quindi ricaricare le prop

        if (this.embedded){
          let _this = this;
          axios.post(this.type !== 'order' ? route('modules.ordini.lista-offerte') : route('modules.ordini.lista-ordini'), { headers: this.headers, sortby: this.sortby, itemsperpage: this.ipp, page: this.page}, {headers: {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json', 'x-inertia': true, 'x-inertia-partial-component' : 'Modules/gestione-ordini/Lista', 'x-inertia-partial-data' : 'items,count' }}).then(response => {
            this.itemsembeddedreload = response.data.props.items;
            this.itemscountreload = response.data.props.count;
          });
        }
        else router.post(window.location.href, { headers: this.headers, sortby: this.sortby, itemsperpage: this.ipp, page: this.page}, { only: ['items', 'count']});
    },
    applyFilters() {
      this.showFilters = false;
      this.reload();
    },
    loadOrdersData()
    {
      router.post(route('modules.gm.evadiDettagli'), { ids: this.selected.map(x=>x.SaleOrdId)}, { only: ['items', 'count']});
    },
    printDocument(documentId) {
      // Apre la stampa in una nuova finestra
      const printUrl = route('modules.ordini.stampa', { id: documentId });
      window.open(printUrl, '_blank');
    },
    goBackToHome() {
      // Emit event to parent component (OrderPanel) to go back to home
      this.$emit('go-back-to-home');
    },
  },
  mounted()
  {
    //Primo caricamento
    this.headers = this.$attrs.headers;
    this.ipp = this.$attrs.ipp;
    this.page = this.$attrs.page;
    this.sortby = this.$attrs.sortby;
  }
};
</script>